import React, { useState, useRef, useEffect } from "react";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import Box from "@mui/material/Box";
import { agentSearchByTerm } from "requests/agent";
import { getPolicyInfo } from "requests/homeowner/ho";
import MGrid, { FILTER_TYPE_NONE } from "components/Shared/MGrid.tsx";
import MCard from "components/Shared/MCard.tsx";
import { phoneNumberFormatter } from "components/Shared/Formatters";
import { DATA_TYPE_PHONE_NUMBER } from "typeConstants/dataTypes";
import PropTypes from "prop-types";

const AgentSearch = ({
  controlIDNumber,
  onAgentSelected,
}) => {
  const [policyInfo, setPolicyInfo] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [agentSearchResults, setAgentSearchResults] = useState();
  const [selectedAgent, setSelectedAgent] = useState();
  const mounted = useRef(true);

  useEffect(() => {
    getPolicyInfo(controlIDNumber, p => setPolicyInfo(p), mounted);
    return () => mounted.current = false;
  }, []);

  const onSearch = () => {
    agentSearchByTerm(searchTerm, policyInfo.customerInfo.majorCompanyId, mounted, a => setAgentSearchResults(a));
  };

  const colDefs = [
    { key: "agentCode", dataSource: "agentCode", name: "Agent Code" },
    { key: "agentName", width: 200, dataSource: "agentName", name: "Agent Name" },
    { key: "emailAddress", width: 200, dataSource: "emailAddress", name: "Email Address" },
    { key: "phoneNumber", width: 110, valueFormatter: phoneNumberFormatter, dataSource: "phoneNumber", name: "Phone" },
  ];

  colDefs.forEach(cd => cd.filterType = FILTER_TYPE_NONE);

  return policyInfo ?
    <div className="agent-search search-panel">
      {selectedAgent ?
        <>
          <MCard
            className="mcard-flat"
            title="Agent Information"
            fields={[
              { label: "Code", value: selectedAgent.agentCode },
              { label: "Name", value: selectedAgent.agentName },
              { label: "Major Company", value: selectedAgent.majorCompanyName },
              { label: "Email", value: selectedAgent.emailAddress },
              { label: "Phone Number", value: selectedAgent.phoneNumber, dataType: DATA_TYPE_PHONE_NUMBER },
              { label: "Fax", value: selectedAgent.faxNumber, dataType: DATA_TYPE_PHONE_NUMBER },
            ]} />
          <Box sx={{ marginTop: 2}}className="button-row-end">
            <Button onClick={() => setSelectedAgent(null)}>Back</Button>
            <Button onClick={() => onAgentSelected(selectedAgent)}>Select</Button>
          </Box>
        </>
        :
        <>
          <div className="search-controls">
            <TextField variant="standard" label="Search Text" sx={{ flexGrow: 1 }} onChange={e => setSearchTerm(e.target.value)} />
            <IconButton onClick={() => onSearch()} sx={{ aspectRatio: 1 }}><SearchIcon /></IconButton>
          </div>
          {agentSearchResults && <MGrid
            columnDefinitions={colDefs}
            data={agentSearchResults}
            onRowClick={i => setSelectedAgent(agentSearchResults[i])}
          />}
        </>}
    </div>
    :
    <div>Loading Agent Search...</div>;
};

AgentSearch.propTypes = {
  controlIDNumber: PropTypes.number, //control id number is used to get the major company code for the agent search
  onAgentSelected: PropTypes.func, //called when an agent is selected
};

export default AgentSearch;
